module.exports = __webpack_public_path__ + "static/GMDWA_cover-666309580ecce172b9cc43c250129e8c.png";